import { selectJBPSettings } from 'legacy/lut/features/partner360/jbpSettings'
import { FC } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'
import { Button } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './QbrLinkButtons.module.scss'

export const QbrLinkButtons: FC = () => {
  const jbpSettings = useSelector(selectJBPSettings)
  const translationMode = useSelector(selectTranslationMode)

  const isTranslationMode = translationMode === 'edit'

  return (
    <div className={styles.root}>
      {jbpSettings.qbrGuideLinks.map((linkItem, index) => {
        if (isTranslationMode) {
          return <Translation key={index} text={linkItem.NameKey} />
        }

        return (
          <Tooltip
            inline
            key={index}
            tipContent={() => (
              <div>
                <Translation text={linkItem.NameKey} actionsInside />
              </div>
            )}
          >
            <Button className={styles.button} href={linkItem.URL} variant="text">
              <i className={linkItem.Icon} />
            </Button>
          </Tooltip>
        )
      })}
    </div>
  )
}
